import { addDoc, collection, doc, updateDoc } from "firebase/firestore";

import { db } from "shared/api/firebase";
import {
  CreateArticleDetailsParams,
  CreateArticleDetailsResponse,
} from "../types";

const createArticleDetails = async ({
  brandId,
  categoryId,
  groupId,
  article,
}: CreateArticleDetailsParams): Promise<CreateArticleDetailsResponse> => {
  const groupRef = collection(db, "legalDocuments", brandId, categoryId);

  const documentsRef = collection(groupRef, groupId, "documents");

  const groupDocRef = doc(groupRef, groupId);

  try {
    const docRef = await addDoc(documentsRef, article);

    await Promise.all([
      updateDoc(docRef, {
        id: docRef.id,
      }),
      updateDoc(groupDocRef, {
        updatedAt: new Date(),
      }),
    ]);

    return { id: docRef.id };
  } catch (error) {
    console.error("Failed to create the article details:", error);
    throw error;
  }
};

export default createArticleDetails;
